import { Ban, ChevronDown, Pencil, Search, Trash2, UsersRound } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import EditRole from "./edit-role";
import DeleteRole from "./delete-role";

const MainRoleManagment = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const menuRef = useRef(null);

  const role = [
    {
      id: 1,
      name: "Ethan Carter",
      email: "ethan.carter@example.com",
      roleType: "Super Admin",
      permission: "All All Permissions",
      status: "Active",
    },
    {
      id: 2,
      name: "Olivia Bennett",
      email: "olivia.bennett@example.com",
      roleType: "Sub-Admin",
      permission: "User Management NGO Approvals",
      status: "Active",
    },
    {
      id: 3,
      name: "Noah Thompson",
      email: "noah.thompson@example.com",
      roleType: "Moderator",
      permission: "Content Moderation Event Oversight",
      status: "Suspended",
    },
    {
      id: 4,
      name: "Ava Harper",
      email: "ava.harper@example.com",
      roleType: "Data Analyst",
      permission: "Reports & Analytics",
      status: "Active",
    },
    {
      id: 5,
      name: "Noah Thompson",
      email: "noah.thompson@example.com",
      roleType: "Moderator",
      permission: "Content Moderation Event Oversight",
      status: "Active",
    },
    {
      id: 6,
      name: "Ava Harper",
      email: "ava.harper@example.com",
      roleType: "Data Analyst",
      permission: "Reports & Analytics",
      status: "Active",
    },
  ];

  const statusClasses = (status) => {
    switch ((status || "").toLowerCase()) {
      case "active":
        return "bg-[#3FE36B] text-black";
      case "suspended":
        return "bg-[#DFCD00] text-black";
      case "expired":
        return "bg-[#DD0000] text-white";
      default:
        return "bg-sky-100 text-sky-700 ring-1 ring-sky-200";
    }
  };

  // Close menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="my-6">
      <div className="flex justify-between items-center gap-x-1">
        <h1 className="font-popinsSemiBold text-xl lg:text-2xl">
          Role Management
        </h1>
        <button
          type="submit"
          className="relative overflow-hidden py-[10px] bg-themeColor text-black font-popinsSemiBold text-sm px-5 rounded-md shadow-lg
           transform transition duration-300 ease-in-out
           hover:bg-[#3FC4E3] hover:scale-105 hover:shadow-[0_0_20px_rgba(63,196,227,0.6)] 
           active:scale-95 active:shadow-inner focus:outline-none
           disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
        >
          <span>Create Sub-Admin</span>
          <span className="absolute inset-0 rounded-full bg-white opacity-0 active:opacity-10 transition-opacity duration-300"></span>
        </button>
      </div>
      <div className="">
        <div className="relative mt-7">
          <input
            type="text"
            placeholder="Search by name or email"
            class="peer w-full font-popinsMedium rounded-md border-2 border-border bg-[#F0F2F5] pl-9 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-[#3FC4E3] focus:shadow-[0_0_3px_#3FC4E3]"
          />
          <div className="absolute left-3 top-3">
            <Search size={18} color="#61708A" />
          </div>
        </div>
        <div className="flex space-x-4 mt-5" ref={menuRef}>
          {/* Location Menu */}
          <div className="relative">
            <button
              className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] shadow-sm hover:bg-gray-100 focus:outline-none flex items-center text-sm gap-x-2"
              onClick={() =>
                setOpenMenu(openMenu === "location" ? null : "location")
              }
            >
              Role Type
              <ChevronDown size={20} />
            </button>
            {openMenu === "location" && (
              <ul className="absolute mt-1 w-56 bg-[#F0F2F5] text-[#121417] text-sm border rounded-md font-popinsRegular shadow-lg z-50">
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/1"
                  onClick={() => {
                    console.log("Location: New York");
                    setOpenMenu(null);
                  }}
                >
                  New York
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/1"
                  onClick={() => {
                    console.log("Location: Los Angeles");
                    setOpenMenu(null);
                  }}
                >
                  Los Angeles
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    console.log("Location: Chicago");
                    setOpenMenu(null);
                  }}
                >
                  Chicago
                </li>
              </ul>
            )}
          </div>

          {/* Services Menu */}
          <div className="relative">
            <button
              className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] flex items-center text-sm gap-x-2 shadow-sm hover:bg-gray-100 focus:outline-none"
              onClick={() =>
                setOpenMenu(openMenu === "services" ? null : "services")
              }
            >
              Status
              <ChevronDown size={20} />
            </button>
            {openMenu === "services" && (
              <ul className="absolute mt-1 w-56 text-[#121417] bg-[#F0F2F5] font-popinsRegular text-sm rounded-md shadow-lg z-50">
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Cleaning");
                    setOpenMenu(null);
                  }}
                >
                  Cleaning
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                  onClick={() => {
                    console.log("Services Offered: Delivery");
                    setOpenMenu(null);
                  }}
                >
                  Delivery
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    console.log("Services Offered: Support");
                    setOpenMenu(null);
                  }}
                >
                  Support
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow border border-border overflow-hidden mt-8">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="w-[20%] px-3 py-3 text-left text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Name
                </th>
                <th className="w-[20%] py-3 text-center text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Email
                </th>
                <th className="w-[10%] py-3 text-center text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Role Type
                </th>
                <th className="w-[20%] py-3 text-center text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Assigned Permissions
                </th>
                <th className="w-[10%] py-3 text-center text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Status
                </th>
                <th className="w-[20%] py-3 text-center text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {role.map((user) => (
                <tr
                  key={user.id}
                  className="hover:bg-gray-50 transition-colors"
                >
                  <td className="px-3 py-4 whitespace-nowrap">
                    <div className="text-sm font-popinsMedium text-gray-900">
                      {user.name}
                    </div>
                  </td>
                  <td className="px-3 py-4">
                    <div className="text-sm font-popinsMedium text-black/50">
                      {user.email}
                    </div>
                  </td>
                  <td className="py-4 whitespace-nowrap">
                    <span className="px-5 py-2 inline-flex text-xs leading-5 font-popinsSemiBold rounded-md bg-gray-200 ">
                      {user.roleType}
                    </span>
                  </td>
                  <td className="px-3 py-4 text-center text-black/50">
                    {user.permission}
                  </td>
                  <td className="py-4 text-center">
                    <span
                      className={`flex justify-center items-center py-[10px] rounded-lg text-sm font-popinsMedium ${statusClasses(
                        user.status
                      )}`}
                    >
                      <span className="w-2 h-2 rounded-full" aria-hidden></span>
                      {user.status}
                    </span>
                  </td>
                  <td className="text-center">
                    <div className="flex gap-x-3 items-center justify-center w-full">
                      <button
                        title="Edit"
                        className="bg-blue-100 p-2 rounded-md"
                        onClick={() => setIsOpen(true)}
                      >
                        <Pencil size={16} className="text-blue-600" />
                      </button>
                      <button
                        title="Suspend"
                        className="bg-yellow-100 p-2 rounded-md"
                      >
                        <Ban size={16} className="text-yellow-600" />
                      </button>
                      <button
                        title="Delete"
                        className="bg-red-100 p-2 rounded-md"
                        onClick={() => setIsDeleteOpen(true)}
                      >
                        <Trash2 size={16} className="text-red-600" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="md:hidden space-y-3">
            {role.map((row) => (
              <div
                key={row.id}
                className="bg-white/80 p-4 rounded-xl shadow-sm border border-border hover:shadow-md transition-shadow duration-200 cursor-pointer"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="w-full">
                    <div className="flex items-center !justify-between gap-2">
                      <div>
                        <p className="font-popinsSemiBold text-base">Name</p>
                        <p className="font-popinsMedium text-sm text-black/50">
                          {row.name}
                        </p>
                      </div>
                      <div>
                        <span
                          className={`flex justify-center items-center py-[10px] rounded-lg text-sm font-popinsMedium ${statusClasses(
                            role.status
                          )}`}
                        >
                          <span
                            className="w-2 h-2 rounded-full"
                            aria-hidden
                          ></span>
                          {role.status}
                        </span>
                      </div>
                    </div>
                    <div className="mt-3">
                      <div className="text-sm flex gap-2 items-center">
                        <p className="font-popinsSemiBold text-base">email:</p>
                        <p className="text-black/50 font-popinsMedium">
                          {row.email}
                        </p>
                      </div>
                      <div className="text-sm mt-2 flex gap-2 items-center">
                        <p className="font-popinsSemiBold text-base">
                          Role Type:
                        </p>
                        <p className="text-black/50 font-popinsMedium">
                          {row.roleType}
                        </p>
                      </div>
                      <div className="text-sm mt-2 flex gap-2 items-center">
                        <p className="font-popinsSemiBold text-base">
                          Assigned Permissions:
                        </p>
                        <p className="text-black/50 font-popinsMedium">
                          {row.permission}
                        </p>
                      </div>
                      <div className="text-sm mt-2 flex gap-2 items-center">
                        <p className="font-popinsSemiBold text-base">
                          Actions:
                        </p>
                        <div className="flex gap-x-3 items-center justify-center w-full">
                          <button
                            title="Edit"
                            className="bg-blue-100 p-2 rounded-md"
                          >
                            <Pencil size={16} className="text-blue-600" />
                          </button>
                          <button
                            title="Suspend"
                            className="bg-yellow-100 p-2 rounded-md"
                          >
                            <Ban size={16} className="text-yellow-600" />
                          </button>
                          <button
                            title="Delete"
                            className="bg-red-100 p-2 rounded-md"
                          >
                            <Trash2 size={16} className="text-red-600" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h3 className="font-popinsSemiBold text-lg">Recent Role Changes</h3>
        <div className="flex gap-x-3 items-center mt-5">
          <Pencil size={22}/>
          <div>
            <p className="font-popinsMedium text-base">Olivia Bennett's role updated to Sub-Admin</p>
            <p className="font-popinsRegular text-sm text-black/50">2 hours ago</p>
          </div>
        </div>
        <div className="flex gap-x-3 items-center mt-5">
          <UsersRound size={22}/>
          <div>
            <p className="font-popinsMedium text-base">Noah Thompson's account suspended</p>
            <p className="font-popinsRegular text-sm text-black/50">5 hours ago</p>
          </div>
        </div>
        <div className="flex gap-x-3 items-center mt-5">
          <Pencil size={22}/>
          <div>
            <p className="font-popinsMedium text-base">Ava Harper's permissions updated</p>
            <p className="font-popinsRegular text-sm text-black/50">1 hours ago</p>
          </div>
        </div>
      </div>
      {isOpen && <EditRole onClose={() => setIsOpen(false)} />}
      {isDeleteOpen && <DeleteRole onClose={() => setIsDeleteOpen(false)} />}
    </div>
  );
};

export default MainRoleManagment;
